import {Component, Input, OnInit} from '@angular/core';
import {Information} from "../information";

@Component({
  selector: 'app-information-fastlink',
  templateUrl: './information-fastlink.component.html',
  styleUrls: ['./information-fastlink.component.css']
})
export class InformationFastlinkComponent  {
  @Input() information: Information;

  constructor() {
    this.information = new Information();
  }



}
